<template>
  <div class="about wrap">
    <SlotPageVisual class="auto">
      <template #visual-bg>
        <div class="img about"></div>
      </template>
      <template #contents>
        <h1 class="visual-title">
          <span data-aos="fade"><span class="hl">R</span>eferences</span>
        </h1>
        <div class="visual-summary"  data-aos="fade-up" data-aos-delay="500">
          <p>{{ $t('about.mainDesc.01') }}</p>
          <p>{{ $t('about.mainDesc.02') }}</p>
          <p>{{ $t('about.mainDesc.03') }}</p>
        </div>
      </template>
    </SlotPageVisual>
    <CompanyStats />
    <CustomerList class="auto" />
    <ReferenceList />
  </div>
</template>

<script>
import CustomerList from '@/components/CustomerList'
import ReferenceList from '@/components/ReferenceList'
import SlotPageVisual from '@/components/SlotPageVisual'
import CompanyStats from '@/components/CompanyStats'

export default {
  name: 'aboutView',
  components: {
    CompanyStats,
    CustomerList,
    ReferenceList,
    SlotPageVisual
  }
}
</script>
